import { AbstractControl, ValidatorFn } from '@angular/forms';

export function timepickerValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const value = control.value;
        if (null !== value) {
            const hours = value.getHours();
            const minutes = value.getMinutes();
            if (hours < 0 || hours > 12) {
                return { outOfRange: true };
            }
            if (minutes < 0 || minutes > 60) {
                return { outOfRange: true };
            }
            return null;
        } else {
            return { outOfRange: true };
        }
        return null;
    };
}

